import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationSP from "./locales/sp/translation.json"
import translationENG from "./locales/eng/translation.json"

// the translations
const resources = {
 
  sp: {
    translation: translationSP,
  },
  en: {
    translation: translationENG,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "sp")
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passp i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "sp",
    fallbackLng: "sp", // use en if detected lng is not available
    keySeparator: false,
    keySeparator: ':',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  i18n.reloadResources()
export default i18n
